import { AsyncPipe, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { PrimeTemplate } from "primeng-v17/api";
import { CardModule } from "primeng-v17/card";
import { DropdownModule } from "primeng-v17/dropdown";
import { InputTextModule } from "primeng-v17/inputtext";
import { SplitterModule } from "primeng-v17/splitter";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { AppendToBodyDirective } from "../../shared/primeng/append-to-body/append-to-body.directive";
import { DropdownEditableColumnAutoFocusDirective } from "../../shared/primeng/dropdown-editable-column-auto-focus/dropdown-editable-column-auto-focus.directive";
import { DropdownHideFixDirective } from "../../shared/primeng/dropdown-hide-fix/dropdown-hide-fix.directive";
import { DropdownOptionsDirective } from "../../shared/primeng/dropdown-options/dropdown-options.directive";
import { DropdownPrePopulateSingleOptionDirective } from "../../shared/primeng/dropdown-pre-populate-single-option/dropdown-pre-populate-single-option.directive";
import { DropdownReadonlyFixDirective } from "../../shared/primeng/dropdown-readonly-fix/dropdown-readonly-fix.directive";
import { SplitterFixDirective } from "../../shared/primeng/splitter-fix/splitter-fix.directive";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiOrganizationCreationComponent } from "./new-ui-gueteGemeinschaftOrganizationCreation.component";

@Component({
  selector: "app-guetegemeinschaft-organization-creation",
  templateUrl: "./gueteGemeinschaftOrganizationCreation.component.html",
  imports: [
    TranslateDirective,
    CardModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    FormElementMapModule,
    TestIdDirective,
    DropdownModule,
    AppendToBodyDirective,
    DropdownEditableColumnAutoFocusDirective,
    DropdownHideFixDirective,
    DropdownOptionsDirective,
    DropdownPrePopulateSingleOptionDirective,
    DropdownReadonlyFixDirective,
    SplitterModule,
    SplitterFixDirective,
    PrimeTemplate,
    Button,
    AsyncPipe,
  ],
})
export class OrganizationCreationComponent extends NewUiOrganizationCreationComponent {}
